import axios from "axios";
import { useState } from "react";
import Swal from "sweetalert2";

const BannerInquiry = () => {
  const [name, setName] = useState<string>("");
  const [phone, setPhone] = useState<string>("");
  const [address, setAddress] = useState<string>("");
  const [service, setService] = useState<string>("");
  const [contents, setContents] = useState<string>("");

  const [loading, setLoading] = useState(false);

  const handlerPostContact = async () => {
    if (!name || !phone || !address) {
      Swal.fire({
        title: "이름, 연락처, 주소를 모두 입력해주세요.",
        icon: "error",
      });
      return false;
    }

    if (phone.length !== 11 || !phone.includes("010")) {
      alert("010을 포함한 연락처를 모두 입력해주세요.");
      return false;
    }

    if (!window.confirm("문의 접수를 위한 개인정보 수집에 동의하시나요?")) {
      return false;
    }

    setLoading(true);

    await axios
      .post("/api/contact", {
        name: name,
        phone: phone,
        address: address,
        service: service,
        type: "",
        contents: contents,
        path: sessionStorage.getItem("path"),
      })
      .then((res) => {
        if (res.data.code === "0000") {
          Swal.fire({
            title: "문의 완료!",
            text: "문의 등록이 완료되었습니다.",
            icon: "success",
          }).then(() => (window.location.href = "/transform"));
        }
      })
      .catch((e) => {
        setLoading(false);
        Swal.fire({
          title: e,
          icon: "error",
        }).then(() => (window.location.href = "/"));
      });
  };
  return (
    <div className="relative w-full h-full bg-white px-3 xs:px-5 pt-5 text-left gmedium">
      <div className=" relative w-full h-full grid grid-cols-2 lg:grid-cols-5 2xl:grid-cols-3 items-center gap-3 lg:gap-5">
        <div className="lg:col-span-2 2xl:col-span-1 relative w-full h-full">
          <label htmlFor="name" className="lg:text-xl">
            이름&nbsp;<span className="text-[var(--red-color)]">*</span>
          </label>
          <input
            type="text"
            placeholder="이름을 입력해주세요"
            value={name}
            id="name"
            onChange={(e) => setName(e.target.value)}
          />
        </div>
        <div className="lg:col-span-3 2xl:col-span-1 relative w-full h-full">
          <label htmlFor="phone" className="lg:text-xl">
            연락처&nbsp;<span className="text-[var(--red-color)]">*</span>
          </label>
          <input
            type="text"
            placeholder="연락처를 입력해주세요"
            value={phone}
            id="phone"
            onChange={(e) =>
              setPhone(
                e.target.value
                  .replace(/[^0-9.]/g, "")
                  .replace(/(\..*)\./g, "$1"),
              )
            }
          />
        </div>
        <div className="col-span-2 lg:col-span-5 2xl:col-span-1 relative w-full h-full">
          <label htmlFor="service1" className="lg:text-xl">
            문의종류
          </label>
          <select
            name="service1"
            id="service1"
            onChange={(e) => setService(e.target.value)}
          >
           <option value="">서비스 목록</option>
            <option value="곰팡이 제거 및 재오염 방지">
              곰팡이 제거 및 재오염 방지
            </option>
            <option value="태양광 크리닝">태양광 크리닝</option>
            <option value="빌딩 크리닝">빌딩 크리닝</option>
            <option value="호텔 제품판매">호텔 제품판매</option>
            <option value="각종 산업시설의 복원크리닝">
              각종 산업시설의 복원크리닝
            </option>
            <option value="중공업 및 건설회사 제품납품">
              중공업 및 건설회사 제품납품
            </option>
            <option value="학교시설 크리닝">학교시설 크리닝</option>
            <option value="드론 크리닝">드론 크리닝</option>
          </select>
        </div>
        <div className="col-span-2 lg:col-span-5 2xl:col-span-3 relative w-full h-full">
          <label htmlFor="address" className="lg:text-xl">
            주소&nbsp;<span className="text-[var(--red-color)]">*</span>
          </label>
          <input
            type="text"
            placeholder="주소를 입력해주세요"
            id="address"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
          />
        </div>
        <div className="col-span-2 lg:col-span-5 2xl:col-span-3 row-span-2 relative w-full h-full">
          <label htmlFor="contents" className="lg:text-xl">
            문의 내용
          </label>
          <div className=" relative w-full h-fit flex items-center gap-2">
            <textarea
              placeholder="내용을 입력해주세요"
              value={contents}
              name="contents"
              id="contents"
              onChange={(e) => setContents(e.target.value)}
            ></textarea>
          </div>
          <div className="relative w-full h-fit sm:flex justify-between items-start gap-3 py-2">
            <div className="flex items-center gap-1">
              <input
                type="checkbox"
                name="privacy"
                id="privacy"
                defaultChecked
                checked={true}
                className="!w-3 !h-3"
              />
              <label htmlFor="privacy">
                <p className="text-xs 3xl:text-sm">
                  개인정보처리방침&nbsp;동의
                </p>
              </label>
            </div>
            <button
              type="button"
              onClick={handlerPostContact}
              disabled={loading}
              className={
                "relative w-full sm:w-fit h-fit pt-2 pb-1 px-14 bg-primary rounded-sm"
              }
            >
              <h5 className="glight text-white">전송하기</h5>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BannerInquiry;
